export default "/iconNotificationConfirm.svg";